import { AjaxFormValidation } from '@common/libs/ajax-form-validation';

export const FormValidation = {
    $form: $('form#SupplierForm'),
    spinnerTpl:
        `<div class="form-text validating">
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            Checking...
        </div>`,

    init() {
        let self = this;
        let validator = new AjaxFormValidation(this.$form, '/suppliers/ajax_validate', 'ajax_signup', {
            onsubmit: false,
            ignore: ":hidden, .ignore",
            errorClass: 'is-invalid',
            validClass: 'is-valid'
        });

        $.validator.addMethod('form_group', (value, element) => {
            let $fields = $(element).closest('.form-group');
            return () => {
                return $fields.find('input:checkbox, input:radio').is(':checked');
            };
        });

        let showValidation = ($containerEl, isValid = true, message = '') => {
            let className = isValid ? 'valid' : 'invalid',
                $validationEl = $containerEl.siblings('.valid-feedback,.invalid-feedback');
            if (!$validationEl.length) {
                $validationEl = $containerEl.find('.valid-feedback,.invalid-feedback');
            }
            $containerEl.find('input,textarea').removeClass('is-valid is-invalid').addClass('is-'+className);
            $validationEl.removeClass('valid-feedback invalid-feedback').addClass(className+'-feedback').show();
            $validationEl.html(message);
        };

        let detectCaps = (el, message) => {
            if (/[A-Z]{4,}/.test(el.value)) {
                showValidation($(el).parent(), false, message);
            }
        };

        let registerProspect = () => {
            //abandonment is underpinned by email as the identifier, don't track if we don't yet have a valid email
            if (!self.$form.find('#MemberEmail').valid()) {
                return;
            }
            $.ajax({
                type: 'POST',
                url: self.$form.attr('action').replace('register', 'register_prospect'),
                data: self.$form.serializeArray(),
                dataType: 'json'
            });
        };

        let validateInput = (el) => {
            validator.validate(el, {}, {
                beforeSend: () => {
                    self.$form.find('[type="submit"]').attr('disabled', true);
                }
            }).always(() => {
                self.$form.find('[type="submit"]').removeAttr('disabled');
                registerProspect();
            });
        };

        let validateInputGroup = (el, callback = false) => {
            let $formGrp = $(el).closest('.form-group'),
                postData = $formGrp.find('input').serialize();

            if (!postData) {
                postData = encodeURI(`${el.name}=0`);
            }

            validator.validate(el, {
                afterValidate: () => {
                    $formGrp.parent().find('.validating').hide();
                },
                beforeValidate: ($el) => {
                    if (!$formGrp.parent().find('.validating').length) {
                        $formGrp.after(self.spinnerTpl);
                    }
                    if (!$formGrp.parent().find('.valid-feedback, .invalid-feedback').length) {
                        $formGrp.after(`<div class="valid-feedback"></div>`);
                    }
                    $formGrp.parent().find('.validating').show();
                    $formGrp.siblings('.validation-message').hide();
                },
                responseCallback: (result) => {
                    if (!result.error) {
                        showValidation($formGrp, true, result.success);
                    }
                    if (typeof callback == 'function') {
                        callback(result);
                    }
                    return result;
                },
                error: ($el, result) => {
                    showValidation($formGrp, false, result.error);
                }
            }, {
                data:  postData,
                beforeSend: () => {
                    self.$form.find('[type="submit"]').attr('disabled', true);
                    $formGrp.parent().find('.valid-feedback, .invalid-feedback').hide();
                },
            }).always(() => {
                self.$form.find('[type="submit"]').removeAttr('disabled');
                $formGrp.find('.valid-feedback, .invalid-feedback').remove();
                registerProspect();
            });
        };

        this.$form.find('.form-check-input').rules('add', 'form_group');

        this.$form.find('.form-control').not('input[readonly], .ignore, .form-select').on('blur', (e) => {
            validateInput(e.target);
        });
        this.$form.on('change', '.form-select', (e) => {
            validator.getValidator().element(e.target);
            validateInput(e.target);
        }).on('change', '.form-check-input', (e) => {
            validateInputGroup(e.target);
        }).on('change', '.address .form-control', (e) => {
            // allow time for google autocomplete to populate
            setTimeout(() => { validateInputGroup(e.target) }, 500);
        });

        // Custom validation

        $('.modal#addProductCategories').on('hide.bs.modal', (e) => {
            let $trigger = $('button[data-bs-target="#addProductCategories"]'),
                categories = [];
            validateInputGroup($(e.target).find('input:checkbox')[0], (result) => {
                showValidation($trigger, !result.error, result.success ? result.success : result.error);
            });
            $.each($(e.target).find('input:checked').siblings('label'), (i, el) => {
                categories.push(el.innerHTML);
            });
            $trigger.siblings('.selected-categories').html(categories.join('<br>'));
        });

        $('.switch-toggle').on('change', 'input:checkbox', (e) => {
            $(e.target).closest('.switch-toggle').find('label').html($(e.target).is(':checked') ? 'Yes' : 'No');
        });

        $('#SupplierForm input:checkbox.toggle-other').on('change', (e) => {
            if ($(e.target).is(':checked')) {
                let target = $(e.target).data('target');
                $(target).removeAttr('disabled');
            }
        });

        $('#SupplierDataCountryId').on('change', (e) => {
            let phone = $('#SupplierDataPhoneNumber').val().replace(new RegExp('^\\+\\d+ ', ''), ''),
                code = $(e.target).attr('data-code');
            $('#SupplierDataPhoneNumber').val(`+${SaleHoo.CountryAreaCodes[code]['code']} ${phone}`);
        });

        // Optional validation

        $('#SupplierDataProducts').blur((e) => {
            detectCaps(e.target, "Please do not use CAPS unless it's for a specific product type.");
        });
        $('#SupplierDataBrands').blur((e) => {
            detectCaps(e.target, "Please do not use CAPS unless it's for a specfic brand name.");
        });
        $('#SupplierDataDescription').blur((e) => {
            detectCaps(e.target, "Please do not use CAPS unless describing a brand (Sentence case preferred).");
        });
        $('#SupplierDataOrderRequirements').blur((e) => {
            detectCaps(e.target, "Please do not use CAPS unless describing a brand (Sentence case preferred).");
        });
    },
};
